import { AppTour } from '../tour.model';

export const HOME_TOUR: AppTour = {
  tourId: 'selfSetup',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: '#side-menu',
      attachTo: { element: '#side-menu', on: 'right' },
      cancelIcon: {enabled: false},
      title: 'tour_home_left_menu_title',
      text: 'tour_home_left_menu_text',
      buttons: [
          { text: 'tour_label_skip', action: 'cancel', className:"btn btn-primary-tertiary btn-primary-tertiary--sm" },
          { text: 'tour_label_next', action: 'next', className:"btn btn-primary btn-primary--sm" }
      ]
    },
    {
      id: '#top-left-menu-guide',
      attachTo: { element: '#top-left-menu-guide', on: 'bottom-start'},
      cancelIcon: {enabled: false},
      title: 'tour_home_top_menu_title',
      text: 'tour_home_top_menu_text',
     buttons: [
          { text: 'Skip', action: 'cancel', className:"btn btn-primary-tertiary btn-primary-tertiary--sm" },
          { text: 'Next', action: 'next', className:"btn btn-primary btn-primary--sm" }
      ]
    },
     {
      id: '#profile-link-guide',
      attachTo: { element: '#profile-link-guide', on: 'bottom-left' },
      cancelIcon: {enabled: false},
      title: 'tour_home_profile_title',
      text: 'tour_home_profile_text',
      buttons: [
          { text: 'tour_label_skip', action: 'cancel', className:"btn btn-primary-tertiary btn-primary-tertiary--sm" },
          { text: 'tour_label_next', action: 'next', className:"btn btn-primary btn-primary--sm" }
      ]
    },
    {
      id: '#overview-manageExpenses',
      attachTo: { element: '#overview-manageExpenses', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_home_manage_expense_title',
      text: 'tour_home_manage_expense_text',
      buttons: [
          { text: 'tour_label_skip', action: 'cancel', className:"btn btn-primary-tertiary btn-primary-tertiary--sm" },
          { text: 'tour_label_next', action: 'next', className:"btn btn-primary btn-primary--sm" }
      ]
    },
     {
      id: '#overview-expenseGraph',
      attachTo: { element: '#overview-expenseGraph', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_home_manage_graph_title',
      text: 'tour_home_manage_graph_text',
      buttons: [
          { text: 'tour_label_skip', action: 'cancel', className:"btn btn-primary-tertiary btn-primary-tertiary--sm" },
          { text: 'tour_label_next', action: 'next', className:"btn btn-primary btn-primary--sm" }
      ]
    },
     {
      id: '#miscOverview',
      attachTo: { element: '#miscOverview', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_home_mis_overview_title',
      text: 'tour_home_mis_overview_text',
      buttons: [
          { text: 'tour_label_got_it', action: 'next', className:"btn btn-primary btn-primary--sm" }
      ]
    },
  ]};

